import React from 'react';
import {Button} from '@spaced-out/ui-design-system';


export interface RecordingActionsProps {
  onConfirm: () => void;
  onCancel: () => void;
  /** aria-labels — pass already-translated (this component does no i18n). */
  cancelLabel?: string;
  confirmLabel?: string;
}

/**
 * Cancel (✕) + stop (✓) controls for the recording state, rendered in the
 * editor's bottom-bar actions slot. Stop finalizes and keeps the transcript;
 * cancel discards it. (The connecting state shows a spinner here instead, so
 * these controls only appear once the stream is live.)
 */
export function RecordingActions({
  onConfirm,
  onCancel,
  cancelLabel,
  confirmLabel,
}: RecordingActionsProps) {
  return (
    <>
      <Button
        type="primary"
        size="small"
        iconLeftName="check"
        onClick={onConfirm}
        aria-label={confirmLabel}
      />
      <Button
        type="danger"
        size="small"
        iconLeftName="close"
        onClick={onCancel}
        aria-label={cancelLabel}
      />
    </>
  );
}
